import type React from 'react';

interface FullscreenToggleButtonProps {
  isFullscreen: boolean;
  onToggle: () => void;
}

const FullscreenToggleButton: React.FC<FullscreenToggleButtonProps> = ({
  isFullscreen,
  onToggle,
}) => {
  return (
    <button
      type='button'
      className='fullscreen-toggle-button'
      onClick={onToggle}
      aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
      title={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}>
      {isFullscreen ? (
        // Exit fullscreen icon (minimize)
        <svg
          width='18'
          height='18'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'>
          <path d='M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3' />
        </svg>
      ) : (
        // Enter fullscreen icon (expand)
        <svg
          width='18'
          height='18'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'>
          <path d='M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3' />
        </svg>
      )}
    </button>
  );
};

export default FullscreenToggleButton;
